export default {
  CONFIRM_PASSWORD: 'Confirmer le mot de passe',
  FORGOT_PASSWORD_CAPTION:
    'Pas de soucis. Saisissez votre nom d’utilisateur et nous vous enverrons un lien de réinitialisation à l’adresse e-mail que vous avez enregistrée.',
  PASSWORD_EMAIL_SUCCESS: 'Un nouveau mot de passe a été envoyé à votre adresse e-mail enregistrée.',
  SENT_EMAIL_TITLE: 'Nouveau mot de passe envoyé',
  INVALID_RESET_PASS_LINK: 'Il semble que le lien de réinitialisation de votre mot de passe ne soit pas valide, veuillez réessayer.',
  RESET_PASS_SUCCESS: 'Votre mot de passe a été réinitialisé avec succès, veuillez vous connecter.',
  RESET_PASS_LINK_EXPIRED: 'Il semble que le lien de réinitialisation de votre mot de passe ait expiré, veuillez réessayer.',
  PASSWORDS_NOT_SAME: 'Le mot de passe et le mot de passe de confirmation doivent être identiques',
  RESET_PASSWORD: 'Réinitialiser le mot de passe',
  RESET_PASSWORD_CAPTION: 'Veuillez saisir votre nouveau mot de passe et cliquer sur le bouton « Envoyer ».'
}
